import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
interface CTAButtonProps extends ButtonProps {
  children: React.ReactNode;
  href?: string;
}
export function CTAButton({
  children,
  href,
  ...props
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };
  return <Button onClick={handleClick} size="lg" fontSize={{
    base: 'md',
    md: 'lg'
  }} fontWeight="bold" textTransform="uppercase" letterSpacing="wide" px={8} py={6} bgGradient="linear(to-r, fire.500, brand.500)" color="white" _hover={{
    bgGradient: 'linear(to-r, fire.400, brand.400)',
    transform: 'scale(1.02)',
    filter: 'brightness(1.2)'
  }} _active={{
    transform: 'scale(0.98)'
  }} transition="all 0.3s ease" className="fire-glow" borderRadius="md" {...props} data-id="element-1">
      {children}
    </Button>;
}